import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'
import * as Constants from '../constants'

export class HolidayTextCell extends GridCell {
  public render() {
    return <td>
      {this.props.dataItem.is_synthetic
      ?
        <input
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.props.dataItem.dispatch({
            field: this.props.field,
            id: this.props.dataItem.id,
            type: Constants.UPDATE_HOLIDAY_FIELD,
            value: e.target.value,
          })}
          value={this.props.dataItem[this.props.field]}>
        </input>
      :
        <span>{this.props.dataItem[this.props.field]}</span>}
  </td>
  }
}



// WEBPACK FOOTER //
// ./src/pages/schedules/holidays/render/holiday_text_cell.tsx